import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <nav
        className={`${
          sidebarOpen ? 'w-25' : 'w-auto'
        } bg-dark text-white p-3 min-vh-100`}
        style={{ transition: 'width 0.3s' }}
      >
        <div className="mb-4">
          <h3>Admin Panel</h3>
          <hr />
        </div>

        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/dashboard')}
            >
              📊 Dashboard
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/appointments')}
            >
              📅 Appointments
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/sliders')}
            >
              🖼️ Sliders
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/categories')}
            >
              📂 Categories
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/services')}
            >
              🏥 Services
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/events')}
            >
              📢 Events
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/gallery')}
            >
              🖼️ Gallery
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/coupons')}
            >
              🎟️ Coupons
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/testimonials')}
            >
              ⭐ Testimonials
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/users')}
            >
              👥 Users
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className="btn btn-dark w-100 text-start"
              onClick={() => navigate('/admin/company')}
            >
              🏢 Company Profile
            </button>
          </li>

          <hr />
          <li className="nav-item">
            <button
              className="btn btn-danger w-100 text-start"
              onClick={handleLogout}
            >
              🚪 Logout
            </button>
          </li>
        </ul>
      </nav>

      {/* Main Content */}
      <div className={sidebarOpen ? 'w-75' : 'w-100'} style={{ transition: 'width 0.3s' }}>
        <div className="bg-light p-3 border-bottom">
          <button
            className="btn btn-outline-dark"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
        </div>
        <div className="p-4">
          {children}
        </div>
      </div>
    </div>
  );
}
